import { type FC } from "react";

import { type RemoteApiSpec } from "../../../../../gql-generated/types";
import { EndpointsDetails } from "../../../common/endpoints";

import { ApiSettingsCardDetails } from "./ApiSettingsCardDetails";

interface ApiSettingsDetailsProps {
    spec: RemoteApiSpec;
}

export const ApiSettingsDetails: FC<ApiSettingsDetailsProps> = ({ spec }) => {
    return (
        <>
            <ApiSettingsCardDetails spec={spec} />
            <EndpointsDetails spec={spec} />
        </>
    );
};
